// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.0001 10.8334C10.4603 10.8334 10.8334 10.4603 10.8334 10 10.8334 9.5398 10.4603 9.16671 10.0001 9.16671 9.53984 9.16671 9.16675 9.5398 9.16675 10 9.16675 10.4603 9.53984 10.8334 10.0001 10.8334ZM10.0001 5.00004C10.4603 5.00004 10.8334 4.62694 10.8334 4.16671 10.8334 3.70647 10.4603 3.33337 10.0001 3.33337 9.53984 3.33337 9.16675 3.70647 9.16675 4.16671 9.16675 4.62694 9.53984 5.00004 10.0001 5.00004ZM10.0001 16.6667C10.4603 16.6667 10.8334 16.2936 10.8334 15.8334 10.8334 15.3731 10.4603 15 10.0001 15 9.53984 15 9.16675 15.3731 9.16675 15.8334 9.16675 16.2936 9.53984 16.6667 10.0001 16.6667Z"
    />
  </svg>
);
const IconDotsVertical = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconDotsVertical;
